const React = require("react");
const PageWrapper = require("./src/components/global/wrappers/PageWrapper").default;

exports.wrapPageElement = ({ element, props }) => {
   return <PageWrapper {...props}>{element}</PageWrapper>
}